import { useEffect, useRef } from "react";

const useSocketListener = (socket, user, eventName, callback) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (user?.companyId && socket && typeof socket.on === "function") {
      const fullEventName = `company-${user.companyId}-${eventName}`;

      const handler = (...args) => callbackRef.current?.(...args);
      console.log(`Registrando listener: ${fullEventName}`);
      socket.on(fullEventName, handler);

      return () => {
        if (socket && typeof socket.off === "function") {
          console.log(`Removendo listener: ${fullEventName}`);
          socket.off(fullEventName, handler);
        }
      };
    }
  }, [socket, user?.companyId, eventName]);
};

export default useSocketListener;
